import { atom } from 'jotai';
import { FlowInstance } from './types';
import { EmptySessionInfo, SessionTimelineTableItem } from '@conviva/organism-components';

enum SummaryStatus {
  INIT,
  GENERATING,
  GOT_LATEST_CONTENT,
}

const allEventList = atom<string[]>([]);
const summaryCollapse = atom<boolean>(false);
const status = atom<SummaryStatus>(SummaryStatus.INIT);
const copyTextAtom = atom<string>('Copy Response');
const selectedEventsAtom = atom<string[]>([]);
const highlightedSessionIdsAtom = atom<string[]>([]);
const selectedFlowAtom = atom<FlowInstance | null>(null);
const selectedSessionAtom = atom<SessionTimelineTableItem>(EmptySessionInfo);
const savedUserTimelineStateAtom = atom<{
  globalFilter: any;
  selectedMetrics: string[];
  timestamp: number;
} | null>(null);

export {
  allEventList,
  summaryCollapse,
  SummaryStatus,
  status,
  copyTextAtom,
  selectedEventsAtom,
  highlightedSessionIdsAtom,
  selectedFlowAtom,
  selectedSessionAtom,
  savedUserTimelineStateAtom,
};
